export const environment = {
  production: false,
  env:'Testing',
  HomeTitle:'Aeromar - Testing environment',
  ApiUrl: 'https://aesrjapitest.clavisco.com/',
  recatpchaSiteKey: '6Ld-kWAqAAAAAFiNdWb_qRHJX56XFCJETQvTBRtp',
  LogRocketId: ''
};
